import React from "react";

/**
 * @param {object} props
 * @param {() => void} props.onClick
 * @param {string} [props.label]
 * @param {string} [props.testId]
 * @param {string} [props.className]
 */
export function HelpButton({
  onClick,
  label = "Aide",
  testId = "cq-help-button",
  className = "cq-help-button",
}) {
  return (
    <button type="button" className={className} onClick={onClick} data-testid={testId} aria-label={label}>
      {label}
    </button>
  );
}
